import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes, faEye } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { Visit } from '~/types/visits';
import './Visits.scss';
import { Button } from '@abm-international/react-components';
import { upsertCustomerNote } from '../../libraries/api';
import { t } from '../../libraries/i18n';
import { tLocal } from '../../libraries/i18nLocal';
import useSWR from 'swr';
import { fetcher } from '../../api';
import PdfModal from '../../components/PdfModal/PdfModal';

interface VisitsNotesProps {
	visit?: Visit;
}

export const VisitsNotes = (props: VisitsNotesProps) => {
	const { visit } = props;
	// const [comment, setComment] = useState(visit?.notes || '');
	// const [commentDisabled, setCommentDisabled] = useState(true);
	const [tab, setTab] = useState(0);
	const tabs = [
		{ label: tLocal('comocat.visits_info.tab_running_orders'), value: 0 },
		{ label: tLocal('comocat.visits_info.tab_history'), value: 1 },
		{ label: tLocal('comocat.visits_info.tab_on_order'), value: 2 }
	];
	const [pdfModal, setPdfModal] = useState<{ open: boolean, url?: string, downloadUrl?: string }>({ open: false });
	const renderPdfModal = () => (
		<PdfModal
			key="pdf-modal"
			file={pdfModal.url}
			downloadUrl={pdfModal.downloadUrl}
			close={() => setPdfModal({ open: false })}
		/>
	);
	const shouldFetch = !!visit?.id;
	const { data } = useSWR(shouldFetch ? `/api/customer.order.history/${visit?.id}/orders?comocat=true` : null, fetcher);
	const { data: productData } = useSWR(shouldFetch ? `/api/customer.order.history/${visit?.id}/products` : null, fetcher);

	const openPdfModal = (id?: string) => {
		if (!id) return null;
		const url = `${process.env.REACT_APP_PORTAL_URL}/api/customer.order.history/${visit?.id}/orders/${id}/pdf`;
		setPdfModal({
			open: true,
			url: url,
			downloadUrl: `${url}?download`
		});
	};

	// useEffect(() => {
	// 	setComment(visit?.notes || '');
	// }, [visit]);

	const renderOrders = (orders: any[] = []) => {
		if (orders.length === 0) {
			return <p style={{
				textAlign: 'center', marginTop: '2rem', fontSize: '1.3rem'
			}}>{tLocal('comocat.visits_info.no_orders')}</p>;
		}
		return (
			<table className="orders-running-table" style={{ width: '100%' }}>
				<div className='orders-table-scroll'>
					<thead>
						<tr>
							<th style={{ minWidth: '6rem' }}>{tLocal('comocat.visits_info.col_delivery_date')}</th>
							<th style={{ minWidth: '3.6rem' }}>{tLocal('comocat.visits_info.col_origin')}</th>
							<th style={{ minWidth: '3rem' }}>{tLocal('comocat.visits_info.col_lines')}</th>
							<th style={{ minWidth: '6rem' }}>{tLocal('comocat.visits_info.col_created')}</th>
							<th>{tLocal('comocat.visits_info.col_status')}</th>
							<th style={{ textAlign: 'right', width: '1%' }}></th>
						</tr>
					</thead>

					<tbody>

						{orders.map((order, idx) => (
							<tr key={idx} onClick={() => openPdfModal(order.id)}>
								<td>{order.deliveredOn ? new Date(order.deliveredOn).toLocaleDateString('nl-NL') : ''}</td>
								<td>{order.origin}</td>
								<td>{order.numberOfLines || tLocal('comocat.visits_info.not_applicable')}</td>
								<td>{order.submittedOn ? new Date(order.submittedOn).toLocaleDateString('nl-NL') : ''}</td>
								<td>{ t(`orders.label_status_${order.status?.code}`, order.status?.value?.data?.eta)}</td>
								<td style={{ textAlign: 'right', width: '1%' }}><FontAwesomeIcon icon={faEye} style={{ color: '#1C9462', cursor: 'pointer', fontSize: '1.3rem' }} title={tLocal('comocat.visits_info.view_order_title')} /></td>
							</tr>
						))}

					</tbody>
				</div>
			</table>
		);
	};

	const renderOrdersOnOrder = (products: any[]=[]) => {
		if (products.length === 0) {
			return <p style={{
				textAlign: 'center', marginTop: '2rem', fontSize: '1.2rem'
			}}>{tLocal('comocat.visits_info.no_products')}</p>;
		}
		return (
			<table className="orders-running-table">
				<div className='orders-table-scroll'>
					<thead>
						<tr>
							<th>{tLocal('comocat.visits_info.col_article')}</th>
							<th>{tLocal('comocat.visits_info.col_pieces')}</th>
							<th>{tLocal('comocat.visits_info.col_ordered')}</th>
							<th>{tLocal('comocat.visits_info.col_status')}</th>
						</tr>
					</thead>

					<tbody>

						{products.map((product, idx) => (
							product?.reserved?.map(reservedItem => (
								<tr key={`${idx}-${reservedItem.date}`} >
									<td>{`${product.id} ${product?.article?.desc} `}</td>
									<td>{reservedItem?.quantity}</td>
									<td>{reservedItem?.date ? new Date(reservedItem.date).toLocaleDateString('nl-NL') : ''}</td>
									<td>{t(`product.label_status_${reservedItem?.status}`)}</td>
								</tr>
							))
						))}

					</tbody>
				</div>
			</table>
		);
	};

	return (
		<aside className='visits-aside'>
			{pdfModal.open && renderPdfModal()}
			{!visit && <p style={{
				 fontSize: '1.4rem', color: '#DB5656'
			}}>{tLocal('comocat.visits_info.select_customer')}</p>}
			<p style={{ color: '#1C9462', fontSize: '1.4rem', fontWeight: 'bold' }}>
				{visit? `${visit.id} - ${visit.name}` : ''}
			</p>


			{/* <div className='notes'>
				<div className='head'>
					<div className='subtitle'>
						<p >Notities</p>
						<p style={{ color: '#1C9462' }}>
							{visit?visit.name:''}
						</p>
					</div>

					{!!visit && <Button style={{ color: '#1C9462' }} onClick={onCancel}>{commentDisabled ? <FontAwesomeIcon icon={faEdit} /> : <FontAwesomeIcon icon={faTimes} />}</Button>}
				</div>
				{!visit && <div style={{
					display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontSize: '1.4rem', color: '#DB5656'
				}}><p className=''>Selecteer een klant om notities te bekijken of toe te voegen.</p></div>}

				{!!visit && <>
					<textarea style={{ fontSize: '1.2rem', minHeight: '10rem', marginBottom: '1rem' }} disabled={commentDisabled} value={comment} onChange={(e) => { e.preventDefault(); e.stopPropagation(); setComment(e.target.value); }} />
					{!commentDisabled && <Button color="green" onClick={onSave} disabled={commentDisabled}>Wijzigingen Opslaan</Button>}
				</>}
			</div> */}

			{!!visit && <div className='orders-info'>
				{/* <div className='tabs'>
					{tabs.map(t => (
						<div className='tab' key={t.value}>
							<Button
								key={t.value}
								onClick={() => setTab(t.value)}
								color={tab === t.value ? 'green' : 'default'}
							>
								{t.label}
							</Button>
						</div>
					))}
				</div> */}

				<div className='button-group'>
					{tabs.map(t => (
						// <div className='tab' key={t.value}>
						<Button
							key={t.value}
							onClick={() => setTab(t.value)}
							color={tab === t.value ? 'green' : 'gray'}
							primary={tab === t.value}
						>
							{t.label}
						</Button>
						// </div>
					))}
				</div>

				<>
					{tab === 0 && renderOrders(
						data?.filter(o => {
							const okStatus = ![ 15, 60].includes(Number(o?.status?.code));
							const today = new Date();
							today.setHours(0, 0, 0, 0);
							const deliveredOn = o.deliveredOn ? new Date(o.deliveredOn) : null;
							const deliveredValid = deliveredOn && deliveredOn >= today;
							return okStatus && deliveredValid && new Date(o.submittedOn) > new Date('2025-01-01');
						})
					)}
					{tab === 1 && renderOrders(data?.filter(o => new Date(o.submittedOn) > new Date('2025-01-01')))}
					{tab === 2 && renderOrdersOnOrder(productData)}
				</>
			</div>}
		</aside>
	);
};
